import './App.css';

import React, { useEffect, useState } from 'react';

import Navbar from './components/Navbar';

// ------------ Update 10.09.2023 ------------ //
const Bolonia = process.env.PUBLIC_URL + '/pdf/Bolonia.pdf';
const Dante_Alighieri = process.env.PUBLIC_URL + '/pdf/Dante-Alighieri.pdf';
const Federico_Fellini = process.env.PUBLIC_URL + '/pdf/Federico-Fellini.pdf';
const Florencja_2023 = process.env.PUBLIC_URL + '/pdf/Florencja-2023.pdf';
const Florencja_tour_2023 = process.env.PUBLIC_URL + '/pdf/Florencja-tour-2023.pdf';
const konspekt_zajęć_sprzedawca = process.env.PUBLIC_URL + '/pdf/konspekt-zajęć-sprzedawca.pdf';
const konspekt_zajęć_TR_Opodatkowanie = process.env.PUBLIC_URL + '/pdf/konspekt-zajęć-TR-Opodatkowanie.pdf';
const konspekt_zajęć_Urlop_wypoczynkowy = process.env.PUBLIC_URL + '/pdf/konspekt-zajęć-Urlop-wypoczynkowy.pdf';
const LeonardoDaVinci = process.env.PUBLIC_URL + '/pdf/LeonardoDaVinci.pdf';
const Miałam_staż_w_Sistema_Turismo = process.env.PUBLIC_URL + '/pdf/Miałam-staż-w-Sistema-Turismo.pdf';
const Monica_Bellucci = process.env.PUBLIC_URL + '/pdf/Monica-Bellucci.pdf';
const Rawenna = process.env.PUBLIC_URL + '/pdf/Rawenna.pdf';
const SAN_MARINO = process.env.PUBLIC_URL + '/pdf/SAN-MARINO.pdf';
const WENECJA = process.env.PUBLIC_URL + '/pdf/WENECJA.pdf';
// -------------------------------------------- //

const poradnik1 = process.env.PUBLIC_URL + '/pdf/poradnik-1.pdf';
const poradnik2 = process.env.PUBLIC_URL + '/pdf/poradnik-2.pdf';
const slownikfoto = process.env.PUBLIC_URL + '/pdf/slownik-foto.pdf';
const slownikinf = process.env.PUBLIC_URL + '/pdf/slownik-inf.pdf';
const slownikrach = process.env.PUBLIC_URL + '/pdf/slownik-rach.pdf';
const Portfolio_Anna_Staszkow = process.env.PUBLIC_URL + '/pdf/Portfolio-Anna-Staszków.pdf';
const Portfolio_Holownia = process.env.PUBLIC_URL + '/pdf/Portfolio-Hołownia.pdf';
const Portfolio_Magdalena_Debert = process.env.PUBLIC_URL + '/pdf/Portfolio-Magdalena-Debert.pdf';
const Portfolio_Maja_Kobita = process.env.PUBLIC_URL + '/pdf/portfolio-maja-kobita.pdf';
const Portfolio_Roksana_Sadowska = process.env.PUBLIC_URL + '/pdf/PORTFOLIO-Roksana-Sadowska.pdf';
const Portfolio_Winiarska = process.env.PUBLIC_URL + '/pdf/portfolio-winiarska.pdf';
const Portfolio_Wisniewski = process.env.PUBLIC_URL + '/pdf/Portfolio-wisniewski.pdf';
const Prezentacja_1 = process.env.PUBLIC_URL + '/pdf/Prezentacja-1.pdf';
const Prezentacja_2 = process.env.PUBLIC_URL + '/pdf/Prezentacja-2.pdf';
const Prezentacja_3 = process.env.PUBLIC_URL + '/pdf/Prezentacja-3.pdf';
// -------------------------------------------- //

const Pani_Jola_1 = process.env.PUBLIC_URL + '/img/pani_jola_1.jpeg';

function Gallery(props: { images: { src: string, alt: string }[] }) {
    return (
        <div className='Gallery'>
            {props.images.map((image) => {
                return (
                    <div className='Gallery__image'>
                        <a href={image.src} target='_blank'><img src={image.src} alt={image.alt} width={'100%'} /></a>
                    </div>
                )
            })}
        </div>
    )
}

const contentHeight = '640px';
function Pdf(props: { src: string }) {
    return (
        <object data={props.src} type="application/pdf" width="100%" height={contentHeight}></object>
    )
}

function YouTubeVideo(props: { src: string }) {
    return (
        <div className='YouTubeVideo'>
            <iframe style={{border: 'none', aspectRatio: '16/9'}} width="100%" height='auto' src={props.src} allowFullScreen></iframe>
        </div>
    )
}

export default function Rezultaty() {
    const [numPages, setNumPages] = useState(null);
    const [pageNumber, setPageNumber] = useState(1);

    useEffect(() => {
        window.scrollTo({top: 0});
    }, [])

    return (
        <>
        <Navbar />
        <div className='App__container'>
            <div className='App'>
                <div className='App__content'>
                    <div className='App__content__title'>
                        Rezultaty
                    </div>
                    <div className='App__content__text'>
                        Rezultaty projektu - prace uczestników, certyfikaty, filmy i zdjęcia.
                    </div>
                    <img src={Pani_Jola_1} alt='Pani Jola' width={'100%'} />
                    <br></br>
                    <div className='App__content_text'>
                        Nauczycielka, która odbywała staż we włoskiej firmie obserwowała pracę z uczniami odbywającymi praktyki. Na podstawie tych obserwacji opracowała materiały, które udostępniła  pracodawcom kształcącym młodocianych pracowników w zawodzie sprzedawca oraz opiekunom praktyk zawodowych w zawodzie technik rachunkowości.
                    </div>
                    <br></br><br></br>
                    <YouTubeVideo src='https://www.youtube.com/embed/PA7esf6eZ1s' />
                    <YouTubeVideo src='https://www.youtube.com/embed/Z_anCf73NZM' />
                    <YouTubeVideo src='https://www.youtube.com/embed/sBlCzJfknlk' />
                    <YouTubeVideo src='https://www.youtube.com/embed/8-NuaPpDEYw' />
                    <YouTubeVideo src='https://www.youtube.com/embed/V3dVj15emII' />
                    <YouTubeVideo src='https://www.youtube.com/embed/Jx8WoT2mqDo' />
                    <YouTubeVideo src='https://www.youtube.com/embed/DEVWKYsv9ss' />
                    <Pdf src={Miałam_staż_w_Sistema_Turismo} />
                    <Pdf src={konspekt_zajęć_TR_Opodatkowanie} />
                    <Pdf src={konspekt_zajęć_Urlop_wypoczynkowy} />
                    <Pdf src={konspekt_zajęć_sprzedawca} />
                    <Pdf src={Portfolio_Holownia} />
                    <Pdf src={Portfolio_Anna_Staszkow} />
                    <Pdf src={Portfolio_Wisniewski} />
                    <Pdf src={Portfolio_Roksana_Sadowska} />
                    <Pdf src={Portfolio_Magdalena_Debert} />
                    <Pdf src={Portfolio_Maja_Kobita} />
                    <Pdf src={Portfolio_Winiarska} />
                    <Pdf src={Prezentacja_1} />
                    <Pdf src={Prezentacja_2} />
                    <Pdf src={Prezentacja_3} />
                    <Pdf src={slownikinf} />
                    <Pdf src={slownikfoto} />
                    <Pdf src={slownikrach} />
                    <Pdf src={poradnik1} />
                    <Pdf src={poradnik2} />
                    <Pdf src={Federico_Fellini} />
                    <Pdf src={Monica_Bellucci} />
                    <Pdf src={Dante_Alighieri} />
                    <Pdf src={LeonardoDaVinci} />
                    <Pdf src={Bolonia} />
                    <Pdf src={Rawenna} />
                    <Pdf src={WENECJA} />
                    <Pdf src={SAN_MARINO} />
                    <Pdf src={Florencja_2023} />
                    <Pdf src={Florencja_tour_2023} />
                </div>
            </div>
            <div className='App__background'></div>
        </div>
        </>
    )
}